/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_1Inputs */



/**
* | output |
* | --- |
* | "Top left" |
*
* @param {Live_Caption_Youtube_Region_1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_1 = /** @type {((inputs?: Live_Caption_Youtube_Region_1Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_1Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En haut à gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Oben links")
	if (locale === "it") return /** @type {LocalizedString} */ ("In alto a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вверху слева")
	if (locale === "es") return /** @type {LocalizedString} */ ("Arriba a la izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("左上")
	if (locale === "ja") return /** @type {LocalizedString} */ ("左上")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाएं से बाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Canto superior esquerdo")
	return /** @type {LocalizedString} */ ("Top left")
});